module.exports = __webpack_public_path__ + "static/media/flipHorizontal.f40628c9.svg";